import { Theme } from '@mui/material';
/**
 * Styling for CcfAgentCopilotRunningSummary
 * @returns CcfAgentCopilotRunningSummary CSS properties as a JSON object
 * @example CcfAgentCopilotRunningSummaryStyles(theme)
*/
const CcfAgentCopilotRunningSummaryStyles = (theme: Theme, lineHeight: number, fontSize: number) => {
  const styles = {
    runningSummaryContainer: { 
      display: 'flex',
      background: theme?.palette?.background?.noteInput, 
      boxShadow: `0rem 0.063rem 0rem 0rem ${theme?.palette?.background?.digitalTag}`,
      position: 'sticky',
      top: 0,
      // padding: '0.75rem',
      // paddingBottom:'0.25rem',
      minHeight: '3.375rem',
      flexDirection: 'column',
    },
    summaryContainer: {
      display: 'flex',
      width: '100%',
      padding: '0.75rem',
      paddingBottom: '0',
      justifyContent: 'space-between',
    },
    ConversationAssistanceContainer: {
      // display: 'flex',
      // background: theme?.palette?.background?.noteInput,
      // boxShadow: `0rem 0.063rem 0rem 0rem ${theme?.palette?.background?.digitalTag}`,
      // position: 'sticky',
      // top: 0,
      padding: '0.75rem',
      //paddingTop: '0',
      //flexDirection:'column',
    },
    summaryText: {
      fontSize: `${fontSize}px`,
      color: theme?.palette?.secondary?.main,
      lineHeight: `${lineHeight}px`,
      //paddingBottom: '10px',
      marginLeft:'10px',
    },
    expandedSummaryText:{
      maxWidth: '100%',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'justify',
      paddingBottom: '10px',
      marginLeft:'10px',
    },
    conversationAssistanceBox:{
      background: theme?.palette?.background?.noteInput,
      boxShadow: 'none',
      cursor: 'pointer',
      '*': {
        wordBreak: 'break-word',
      },

      '.MuiPaper-root': {
        background: theme?.palette?.background?.noteInput,
        '.ac-container':{
          background: theme?.palette?.background?.paper
        }
      }
      
    },
    topicsHeading: {
      fontWeight:'700',
      fontSize: '12px',
      color: '#526B7A',
      textTransform :'uppercase',
      lineHeight: `${lineHeight}px`,
      marginLeft:'10px',

    },
    conversationAssistanceContainer:{
      display: 'flex',
      background: '#fff', 
      justifyContent: 'space-between',
    },
    copilotContent: {
      color: theme?.palette?.text?.contrastText,
      margin: '0.625rem',
      borderRadius: '0.5rem',
      backgroundColor: theme?.palette?.background?.paper,
    },
    copilotCard: {
      background: theme?.palette?.background?.paper,
      boxShadow: 'none',
      cursor: 'pointer',
      '*': {
        wordBreak: 'break-word',
      },

      '.ac-container.ac-adaptiveCard':{
        backgroundColor: '#ECF3F8 !important',
        padding: '0px !important',

        '#conversationAssistance': {
          padding: '10px !important',
          borderRadius: '3px'
        },
      },
    }, 
  }
  return styles
}

export default CcfAgentCopilotRunningSummaryStyles